module.exports = __webpack_public_path__ + "img/feat_auto.1285b9f5.png";